import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

const ANS = {
  disponibile: { label: "Sì", verb: "sei disponibile", btn: "bg-emerald-500 hover:bg-emerald-600 text-slate-950", done: "Disponibilità registrata" },
  non_disponibile: { label: "No", verb: "NON sei disponibile", btn: "bg-red-500 hover:bg-red-600 text-white", done: "Indisponibilità registrata" },
  forse: { label: "Forse", verb: "forse sei disponibile", btn: "bg-violet-500 hover:bg-violet-600 text-white", done: "Risposta 'Forse' registrata" },
};

export function CalRespond({ r, dateLabel, onDone }) {
  const [ans, setAns] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await api.put(`/requests/${r.id}/respond`, { answer: ans, message: ans === "non_disponibile" ? undefined : note || undefined });
      toast.success(ANS[ans].done);
      setAns(null);
      onDone && onDone();
    } catch (err) {
      toast.error(err.response?.status === 404 ? "Questa richiesta non esiste più" : formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };
  const name = r.event_name || r.title || "Disponibilità";
  return (
    <div className="rounded-xl border border-yellow-400/60 bg-yellow-400/10 p-3 space-y-2" data-testid={`cal-respond-${r.id}`}>
      <div>
        <p className="font-medium truncate text-yellow-200">{name}</p>
        <p className="text-xs text-yellow-300/80">{r.slot_start ? `Orario ${r.slot_start}–${r.slot_end} · ` : ""}Richiesta in attesa della tua risposta</p>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {Object.entries(ANS).map(([k, a]) => (
          <Button key={k} size="sm" data-testid={`cal-respond-${k}-${r.id}`} onClick={() => { setAns(k); setNote(""); }}
            className={`font-semibold ${a.btn}`}>{a.label}</Button>
        ))}
      </div>
      <AlertDialog open={!!ans} onOpenChange={(o) => { if (!o && !busy) setAns(null); }}>
        <AlertDialogContent className="bg-slate-900 border-slate-700 text-slate-100" data-testid="cal-respond-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Confermi la risposta “{ans && ANS[ans].label}”?</AlertDialogTitle>
            <AlertDialogDescription className="text-slate-400">
              Stai dicendo che {ans && ANS[ans].verb} per <strong className="text-slate-200">{name}</strong> il {dateLabel}.
            </AlertDialogDescription>
          </AlertDialogHeader>
          {ans && ans !== "non_disponibile" && (
            <Textarea data-testid="cal-respond-note" value={note} onChange={(e) => setNote(e.target.value)}
              placeholder="Aggiungi una nota per il manager (opzionale)" className="bg-slate-800 border-slate-700" />
          )}
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="cal-respond-cancel" className="border-slate-700 bg-transparent text-slate-300">Annulla</AlertDialogCancel>
            <AlertDialogAction data-testid="cal-respond-confirm" disabled={busy} onClick={(e) => { e.preventDefault(); send(); }}
              className={ans ? ANS[ans].btn : ""}>Sì, confermo</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
